var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.70361 0.926025H46.2962V36.1112H33.3332V49.0742H3.70361V0.926025Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4B2B2",
    fillRule: "evenodd",
    d: "M35.1851 37.9631H46.2962L35.1851 49.0742V37.9631Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M35.1851 37.9631H46.2962L35.1851 49.0742V37.9631Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E0E0",
    d: "M37.8557 20.4076C37.8773 20.1015 37.9017 19.7982 37.9017 19.4894C37.9017 12.8916 32.5531 7.54297 25.9552 7.54297C25.6465 7.54297 25.3432 7.56734 25.0371 7.58901V20.4076H37.8557Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M23.198 22.2465V9.42798C16.9785 9.90355 12.174 15.088 12.1724 21.3257C12.1724 21.6371 12.1967 21.9405 12.2184 22.2465C12.671 28.1127 17.3318 32.7735 23.198 33.2261C23.504 33.2478 23.8074 33.2721 24.1188 33.2721C30.3565 33.2705 35.541 28.466 36.0165 22.2465H23.198Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.55b462482f3b23452548a84ab62c825b.svg";
export { ForwardRef as ReactComponent };